import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-available',
    templateUrl: './not-available.component.html',
    styleUrls: ['./not-available.component.scss']
})
export class NotAvailableComponent implements OnInit {

    public notAvailableMessage: string = 'La página no está disponible.<br/>Por favor, inténtelo de nuevo más tarde.';
    public returnButtonText: string = 'Volver a la página principal';
    public returnButtonUrl: string = '/home';

    constructor() { }

    ngOnInit() { }

}
